import React, { useState } from "react";
import { format } from "date-fns";

// ICON IMPORTS
import picked from "../../assets/Picked.svg";
import pickedGreen from "../../assets/Picked-green.svg";

import orderOnBus from "../../assets/Order-on-the-Bus.svg";
import orderOnBusGreen from "../../assets/Order-on-the-Bus-green.svg";

import busPickup from "../../assets/Bus-Pickup.svg";
import busPickupGreen from "../../assets/Bus-Pickup-green.svg";

import delivered from "../../assets/Delivered.svg";
import deliveredGreen from "../../assets/Delivered-green.svg";
import { Modal, Button, Input } from "antd";
import axios from "axios";
import { toast } from "react-toastify";

// Add packed status icons
import packed from "../../assets/Tracking/packed.svg";
import yetToPack from "../../assets/Tracking/yettopack.svg";

import customericon from "../../assets/Customer.svg";

const Trackingmessage = ({trackingInfo, orderInfo }) => {
  const [openAccordion, setOpenAccordion] = useState(0); // First accordion is open by default
  const [enquiryModalVisible, setEnquiryModalVisible] = useState(false);
  const [queryDescription, setQueryDescription] = useState('');
  // const [selectedOrder, setSelectedOrder] = useState(null);
  
  const orderData = trackingInfo;
  const API_URL = process.env.REACT_APP_API_URL;
  const hospitalId = localStorage.getItem("hospitalid") || "";
  const toggleAccordion = (index) => {
    setOpenAccordion((prev) => (prev === index ? -1 : index));
  };

  const formatDate = (dateStr) => {
    return format(new Date(dateStr), "dd MMM yyyy, hh:mm a");
  };

  const STATUS_STEPS = [
    {
      key: "packed",
      label: "packed",
      icon: picked,
      activeIcon: pickedGreen,
    },
    {
      key: "picked",
      label: "picked",
      icon: picked,
      activeIcon: pickedGreen,
    },
    {
      key: "order-on-the-bus",
      label: "order-on-the-bus",
      icon: orderOnBus,
      activeIcon: orderOnBusGreen,
    },
    {
      key: "bus-pickup",
      label: "bus-pickup",
      icon: busPickup,
      activeIcon: busPickupGreen,
    },
    {
      key: "delivered",
      label: "delivered",
      icon: delivered,
      activeIcon: deliveredGreen,
    },
  ];

   const handleEnquiryModal = () =>{
    // setSelectedOrder(order);
    setEnquiryModalVisible(true); 
    setQueryDescription(''); // Reset the input each time modal opens
  }
    const handleEnquiryModalClose = () => {
    setEnquiryModalVisible(false);
    // setSelectedOrder(null);
  };
  const handleEnquiry = async () => {
    console.log(orderInfo, orderInfo.patientId, "order");
    const token = localStorage.getItem("auth_token");
        const tenantId = localStorage.getItem("tenantId");
    const response = await axios.get(
      `${API_URL}patient/search?patientId=${orderInfo.patientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      }
    );
    if(response.data.length == 0){
      toast.error("No Patient Found")
      return
    }

    const Patientdata = response?.data.data[0];
    const payload = {
      patientDetails: {
        // patientdetailsid: "",
        patientId: orderInfo.patientId,
        medicaseId: "",
        patientName: `${Patientdata.firstName} ${Patientdata.lastName}`,
        dob: Patientdata.dob,
        gender: Patientdata.gender,
        mobileNumber: Patientdata.mobileNumber,
        email: "",
        escallationNumber: "",
        address: Patientdata.address,
        pincode: Patientdata.pinCode,
      },
      serviceDetailsMessage: queryDescription,
      tickeType: "LAB_TEST",
      ticketSource: "HOSPITAL360",
      hospitalId: hospitalId,
    };
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/add-ticket-d2c`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const Data = await res.json();
      if (Data.status == 200) {
        toast.success(Data.message);

        // Make the second API call with the ticket ID from the first response
        const ticketId = Data.data.id;
        const orderId = orderInfo.id;

        try {
          const secondRes = await fetch(
            `${API_URL}createenquiry/order?orderId=${orderId}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
              body: JSON.stringify({
                ticketId: ticketId,
                ticketStatus: "INPROGRESS",
            
              }),
            }
          );

          if (secondRes.ok) {
            // Handle plain text response
            const responseText = await secondRes.text();
            toast.success(responseText || "Enquiry ticket added successfully");
            console.log("Second API response:", responseText);
            setEnquiryModalVisible(false);
              //  setSelectedOrder(null);
               setQueryDescription('');
            // Reload the page to show updated status
            window.location.reload();
          } else {
            // Try to get error message from response
            let errorMessage = "Failed to create enquiry. Please try again later.";
            try {
              const errorData = await secondRes.json();
              errorMessage = errorData.message || errorMessage;
            } catch (e) {
              // If JSON parsing fails, try text
              try {
                const errorText = await secondRes.text();
                errorMessage = errorText || errorMessage;
              } catch (textError) {
                console.error("Could not parse error response:", textError);
              }
            }
            toast.error(errorMessage);
            console.error("Second API error:", errorMessage);
          }
        } catch (secondError) {
          toast.error("Failed to create enquiry. Please try again later.");
        }
      } else {
        toast.error("Failed to register ticket. Please try again later.");
      }
      console.log(Data, "dxfghj");
    } catch (error) {
      console.error("Failed to register ticket", error);
    }
  };

  return (
    <>
      {/* Regular div instead of modal */}
      <div className="bg-white rounded-lg shadow-sm py-2 px-6 mb-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-0 gap-2 sm:gap-4">
          <div className="flex justify-between items-center w-full">
            <div>
              <h2 className="text-lg sm:text-xl font-bold text-[#003F6B] mb-1">
                Order No: {orderData?.orderNo || "N/A"}
              </h2>
              {orderData?.status && (
                <h2 className="text-sm sm:text-base font-bold text-green-600">
                  Status: {orderData.status}
                </h2>
              )}
            </div>
          {(!orderInfo.enquiryTickets || orderInfo.enquiryTickets.length === 0) && (
            <div>
              <img
                className="cursor-pointer w-8 h-8"
                title="Customer Support"
                src={customericon}
                alt="Customer"
                onClick={() => handleEnquiryModal()}
              />
            </div>
          )}
          </div>

          {orderData?.consignmentId && (
            <div className="text-left sm:text-right mt-2 sm:mt-0 w-full sm:w-auto">
              <p className="text-xs sm:text-sm text-gray-500">Consignment ID</p>
              <p className="font-mono text-xs sm:text-sm font-semibold text-gray-900 break-all overflow-wrap-anywhere">
                {orderData.consignmentId}
              </p>
            </div>
          )}
        </div>

        {/* Error Message Display */}
        {orderData?.message && (
          <div className="w-full text-center py-8 sm:py-16 text-sm sm:text-lg font-semibold text-red-600 bg-red-50 rounded-lg border border-red-200">
            <p className="px-2">{orderData.message}</p>
          </div>
        )}

        {/* If Consignments Not Created */}
        {!orderData?.message && orderData?.consignments === "Consignments Not Created Yet" ? (
          <div className="w-full py-2 sm:py-4 text-sm sm:text-base font-semibold text-gray-700 ">
            <p className="">Consignments have not been created yet for this order.</p>
          </div>
        ) : (
          <>
            {orderData?.consignments && Array.isArray(orderData.consignments) && orderData.consignments.map((consign, index) => {
              // Add lab test data to consignment if available
              const consignmentWithLabTests = {
                ...consign,
                labTests: orderData.labTests || null
              };
              return (
                  <div
                    key={index}
                    className="border border-gray-200 rounded-lg mb-4 shadow-sm"
                  >
                    <button
                      onClick={() => toggleAccordion(index)}
                      className="w-full text-left px-3 sm:px-6 py-2 bg-gray-100 hover:bg-gray-200 rounded-t-lg flex justify-between items-center"
                    >
                      <span className="font-semibold text-gray-800 text-sm sm:text-base break-all pr-2">
                        Consignment ID: {consign.id}
                      </span>
                      <span className="text-gray-500 text-lg sm:text-xl flex-shrink-0">
                        {openAccordion === index ? "−" : "+"}
                      </span>
                    </button>

                    {/* Accordion Content */}
                    {openAccordion === index && (
                      <div className="p-3 sm:p-6 bg-white">
                        {/* Status Tracker with Icons */}
                        <div className="relative mb-4 sm:mb-6">
                          {/* Vertical dotted line for mobile */}
                          <div className="absolute left-3 top-0 bottom-0 w-0.5 border-l-2 border-dashed border-gray-300 sm:hidden"></div>
                          
                          {/* Desktop horizontal layout */}
                          <div className="hidden sm:flex sm:justify-between sm:items-center">
                            {STATUS_STEPS.map((step, idx) => {
                              const isReached = consign.status.some((s) => {
                                const stepKey = step.key.toLowerCase();
                                const statusKey = s.status.toLowerCase();
                                
                                if (stepKey === "packed" && statusKey === "packed") return true;
                                if (stepKey === "picked" && statusKey === "picked") return true;
                                if (stepKey === "order-on-the-bus" && statusKey.includes("order") && statusKey.includes("bus")) return true;
                                if (stepKey === "bus-pickup" && statusKey.includes("bus") && statusKey.includes("pickup")) return true;
                                if (stepKey === "delivered" && statusKey === "delivered") return true;
                                
                                return stepKey.includes(statusKey) || statusKey.includes(stepKey);
                              });
                              
                              const shouldShowGreen = orderData.status === "DELIVERED" || isReached;
                              return (
                                <div key={step.key} className="flex-1 flex items-center min-w-0">
                                  <div className="flex flex-col items-center text-center">
                                    <div className={`p-2 rounded-lg ${
                                      shouldShowGreen ? "bg-green-50" : "bg-gray-50"
                                    }`}>
                                      <img
                                        src={shouldShowGreen ? step.activeIcon : step.icon}
                                        alt={step.label}
                                        className="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10"
                                      />
                                    </div>
                                    <span className={`text-xs font-medium mt-1 ${
                                      shouldShowGreen ? "text-green-700" : "text-gray-500"
                                    }`}>
                                      {step.label}
                                    </span>
                                  </div>
                                  {idx < STATUS_STEPS.length - 1 && (
                                    <div className={`flex-1 h-px mx-1 sm:mx-2 ${
                                      shouldShowGreen ? "bg-green-300" : "bg-gray-300"
                                    }`}></div>
                                  )}
                                </div>
                              );
                            })}
                          </div>

                          {/* Mobile vertical layout */}
                          <div className="sm:hidden space-y-6 pl-2">
                            {STATUS_STEPS.map((step, idx) => {
                              const isReached = consign.status.some((s) => {
                                const stepKey = step.key.toLowerCase();
                                const statusKey = s.status.toLowerCase();
                                
                                if (stepKey === "packed" && statusKey === "packed") return true;
                                if (stepKey === "picked" && statusKey === "picked") return true;
                                if (stepKey === "order-on-the-bus" && statusKey.includes("order") && statusKey.includes("bus")) return true;
                                if (stepKey === "bus-pickup" && statusKey.includes("bus") && statusKey.includes("pickup")) return true;
                                if (stepKey === "delivered" && statusKey === "delivered") return true;
                                
                                return stepKey.includes(statusKey) || statusKey.includes(stepKey);
                              });
                              
                              const shouldShowGreen = orderData.status === "DELIVERED" || isReached;
                              return (
                                <div key={step.key} className="flex items-start relative">
                                  {/* Status indicator circle */}
                                  <div className={`w-3 h-3 rounded-full border-2 z-10 ${
                                    shouldShowGreen 
                                      ? "bg-green-500 border-green-500" 
                                      : "bg-white border-gray-300"
                                  }`}></div>
                                  
                                  {/* Content */}
                                  <div className="ml-4 flex-1">
                                    <div className="flex items-center">
                                      <div className={`p-2 rounded-lg ${
                                        shouldShowGreen ? "bg-green-50" : "bg-gray-50"
                                      }`}>
                                        <img
                                          src={shouldShowGreen ? step.activeIcon : step.icon}
                                          alt={step.label}
                                          className="w-6 h-6"
                                        />
                                      </div>
                                      <div className="ml-3">
                                        <h4 className={`text-sm font-medium ${
                                          shouldShowGreen ? "text-green-700" : "text-gray-700"
                                        }`}>
                                          {step.label.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase())}
                                        </h4>
                                        <p className="text-xs text-gray-500 mt-1">
                                          {shouldShowGreen ? "Completed" : "Pending"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        {/* Status History */}
                     
                        {/* Item Table */}
                        <div className="overflow-x-auto">
                          <table className="min-w-full text-xs sm:text-sm border border-collapse border-gray-300">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="p-2 sm:p-3 border border-gray-300 text-left">
                                  {consignmentWithLabTests.labTests ? 'Test Name' : 'Item Name'}
                                </th>
                                <th className="p-2 sm:p-3 border border-gray-300 text-center">
                                  {consignmentWithLabTests.labTests ? 'Lab Partner' : 'Quantity'}
                                </th>
                                {consignmentWithLabTests.labTests && (
                                  <th className="p-2 sm:p-3 border border-gray-300 text-center">
                                    Amount
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {consignmentWithLabTests.labTests ? (
                                // Lab Tests
                                consignmentWithLabTests.labTests.map((test, idx) => (
                                  <tr key={idx}>
                                    <td className="p-2 sm:p-3 border border-gray-300">
                                      <div className="break-words">
                                        <div className="font-medium">{test.labTestName}</div>
                                        {test.labTestId && (
                                          <div className="text-xs text-gray-500">ID: {test.labTestId}</div>
                                        )}
                                      </div>
                                    </td>
                                    <td className="p-2 sm:p-3 border border-gray-300 text-center">
                                      {test.labPartnerName || 'N/A'}
                                    </td>
                                    <td className="p-2 sm:p-3 border border-gray-300 text-center">
                                      ₹{test.amount}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                // Regular Items
                                consignmentWithLabTests.itemDetails.map((item, idx) => (
                                  <tr key={idx}>
                                    <td className="p-2 sm:p-3 border border-gray-300">
                                      <div className="break-words">{item.itemDetails}</div>
                                    </td>
                                    <td className="p-2 sm:p-3 border border-gray-300 text-center">
                                      {item.quantity}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
              );
            })}
          </>
        )}
      </div>
       <Modal
              title="Order Enquiry"
              visible={enquiryModalVisible}
              onCancel={handleEnquiryModalClose}
              footer={[
                <Button key="back" onClick={handleEnquiryModalClose}>
                  Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleEnquiry}>
                  Submit
                </Button>,
              ]}
            >
              {
                <div>
                 <p><strong>Order ID:</strong> {orderInfo?.id}</p>
                  <p><strong>Patient Name:</strong> {orderInfo?.patientName}</p>
      
                  <Input.TextArea
                    rows={4}
                    value={queryDescription}
                    onChange={(e) => setQueryDescription(e.target.value)}
                    placeholder="Enter your query description here..."
                  />
                </div>
              }
            </Modal>
    </>
  );
};

export default Trackingmessage;

